import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getProperty } from '@go-client/lib/api/property';
import { getPropertyEventTemplates } from '@go-client/lib/api/eventTemplate';
import { getPropertyContentTemplates } from '@go-client/lib/api/contentTemplate';
import { getVenueTemplateById } from '@go-client/lib/api/venueTemplate';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const LibraryTranslationsLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (body.property) {
          const property = await getProperty(body.property);
          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'name',
              to: 'property',
            },
          ]);

          if (body.refers) {
            let translationFields = {};
            if (body.type === 'eventtemplate') {
              const eventTemplates = await getPropertyEventTemplates(body.property);
              const eventTemplate = eventTemplates.find(et => et._id === body.refers)!;
              translationFields = FieldsReplacer(eventTemplate, logFields, [
                {
                  from: 'title',
                  to: 'refers',
                },
              ]);
            } else if (body.type === 'contenttemplate') {
              const contentTemplate = (await getPropertyContentTemplates(body.property)).find(
                ct => ct._id === body.refers
              )!;
              translationFields = FieldsReplacer(contentTemplate, logFields, [
                {
                  from: 'name',
                  to: 'refers',
                },
              ]);
            } else if (body.type === 'venuetemplate') {
              const venueTemplate = await getVenueTemplateById(body.property, body.refers);
              translationFields = FieldsReplacer(venueTemplate, logFields, [
                {
                  from: 'name',
                  to: 'refers',
                },
              ]);
            }

            setLogFields({ ...logFields, ...propertyFields, ...translationFields });
          }
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
